var map = {
	"./Infinix.png": 623,
	"./airpods.jpg": 281,
	"./alexa.jpg": 449,
	"./avatar.png": 987,
	"./camera.jpg": 129,
	"./iPhone9.jpg": 857,
	"./mouse.jpg": 97,
	"./phone.jpg": 836,
	"./playstation.jpg": 939,
	"./sample.jpg": 544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;